import React from 'react';
import styles from './index.module.styl';
type ContentPageProps = {
  header?: React.ReactNode;
  children?: React.ReactNode;
};
export function ContentPage(props: ContentPageProps) {
  return <div className={styles.wrapper} data-sentry-component="ContentPage" data-sentry-source-file="index.tsx">
      {props.header}
      <div className={styles.wrapperContent}>{props.children}</div>
    </div>;
}